//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "SMCOIAM",
  data() {
    return {
      form: {
        f1: "",
        f2: "",
        f3: "",
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: "1", name: "3cm以下" },
        { value: "2", name: "3cm~6cm" },
        { value: "3", name: "6cm以上" },
      ],
      dataList2: [
        { value: "0", name: "非功能区" },
        { value: "1", name: "功能区" },
      ],
      dataList3: [
        { value: "0", name: "表浅静脉引流" },
        { value: "1", name: "深部静脉引流"},
      ],
      levelList: ['I','II','III','IV','V']
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      console.log(result);
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Neuro/SMCOIAM.vue